import {Box} from '@mui/material';
import React from 'react';
import styles from './page-footer.module.scss';

interface Props {
    children: any;
}

export default function PageFooter({children}: Props) {
    return (
        <Box className={styles.pageFooter}>
            {children}
        </Box>
    );
}
